module.exports = __webpack_public_path__ + "img/card1-bl3.5ab47ad0.svg";